/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TournamentMatchmakingMode {
    FullTournament = 'FULL_TOURNAMENT',
    EventStyle = 'EVENT_STYLE'
}


export function instanceOfTournamentMatchmakingMode(value: any): boolean {
    for (const key in TournamentMatchmakingMode) {
        if (Object.prototype.hasOwnProperty.call(TournamentMatchmakingMode, key)) {
            if (TournamentMatchmakingMode[key as keyof typeof TournamentMatchmakingMode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TournamentMatchmakingModeFromJSON(json: any): TournamentMatchmakingMode {
    return TournamentMatchmakingModeFromJSONTyped(json, false);
}

export function TournamentMatchmakingModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentMatchmakingMode {
    return json as TournamentMatchmakingMode;
}

export function TournamentMatchmakingModeToJSON(value?: TournamentMatchmakingMode | null): any {
    return value as any;
}

export function TournamentMatchmakingModeToJSONTyped(value: any, ignoreDiscriminator: boolean): TournamentMatchmakingMode {
    return value as TournamentMatchmakingMode;
}

